import { appConfig } from '../app.js';
import { lugna } from './lugna.js';
import { protector } from './protector.js';
export * from './types.js';
export { lugna } from './lugna.js';
export { protector } from './protector.js';
export { brandThemeConfig } from './theme.js';
export const brands = { lugna, protector };
/**
 * Resolves the active brand. Precedence: explicit argument (frontends pass
 * import.meta.env.VITE_BRAND), then the BRAND env var, then the app default.
 */
/**
 * Parent brand website for a market region, falling back to the brand's
 * first-listed site when the planner sells in a region the brand has no
 * dedicated site for.
 */
export function brandWebsiteUrl(brand, regionCode) {
    const url = brand.websiteUrl[regionCode.toLowerCase()] ?? Object.values(brand.websiteUrl)[0];
    if (!url) {
        throw new Error(`Brand "${brand.id}" has no website URLs configured`);
    }
    return url;
}
export function getBrand(brandId) {
    // Avoid a hard dependency on Node types: this package is consumed by both
    // Node (backend, CDK) and browser bundles, where `process` may not exist.
    const proc = globalThis.process;
    const id = brandId ?? proc?.env?.BRAND ?? appConfig.defaultBrand;
    const brand = brands[id];
    if (!brand) {
        throw new Error(`Unknown brand "${id}". Configured brands: ${Object.keys(brands).join(', ')}`);
    }
    return brand;
}
export function getAdminBrand(brandId) {
    const brand = getBrand(brandId);
    return {
        ...brand,
        fonts: { ...brand.fonts, ...brand.admin?.fonts },
        logos: { ...brand.logos, ...brand.admin?.logos },
    };
}
//# sourceMappingURL=index.js.map